import Inputmask from "inputmask";

$(document).ready(function() {

    const $maskedInput = $(".js-masked-input");

    $maskedInput.each(function(){

        let input = $(this).get(0),
            mask = $(this).attr("data-mask");

        var im = new Inputmask(mask);
        im.mask(input);
    });
});
